import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAccessPoint } from '@obvious.tech/constellation'

export const AccessPoint = defineEntity('AccessPoint', {
  endpoint: 'accesscontrol/api/AccessPoint',
  schema: SNoop<IAccessPoint>(),
})
